import styled from 'styled-components';

export const StyledCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1), 0 1px 2px rgba(16, 24, 40, 0.06);
  border: 1px solid #EAECF0;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  height: 100%;
  position: relative;
  z-index: 1;

  &:hover,
  &:focus-within,
  &:has(.show) {
    z-index: 10;
  }

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(16, 24, 40, 0.1), 0 2px 4px -1px rgba(16, 24, 40, 0.06);
    transform: translateY(-1px);
  }
`;

export const CardHeader = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #EAECF0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const CardTitle = styled.h3`
  font-family: ${props => props.theme.typography.fontFamily.base};
  font-size: ${props => props.theme.typography.fontSize.md};
  font-weight: 700;
  color: ${props => props.theme.colors.text.primary};
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.01em;
`;

export const CardBody = styled.div`
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CardFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #EAECF0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Card/components/CardStyles.js